import React from 'react';
import { observer } from 'mobx-react-lite';
import { useGenerateProposalPageStore } from 'store/pages/proposal-generation/generateProposalPageStore';
import ProposalGenerationStepHeader from '../ProposalGenerationStepHeader';
import { RadioGroupStyled } from './styles';
import {
  A_Z_ORDER_OPTION,
  A_Z_ORDER_OPTION_TEST_ID,
  CART_ITEMS_ORDER_OPTION,
  CART_ITEMS_ORDER_OPTION_TEST_ID,
  DISPLAY_ORDER_OPTION,
  DISPLAY_ORDER_OPTION_TEST_ID,
  RATES_HIGH_TO_LOW_OPTION,
  RATES_HIGH_TO_LOW_OPTION_TEST_ID,
  RATES_LOW_TO_HIGH_OPTION,
  RATES_LOW_TO_HIGH_OPTION_TEST_ID,
  SECOND_STEP_TEST_ID,
} from '../constants';

const radioButtons = [
  {
    label: 'Match order plans put into cart',
    value: 'cart-items',
    id: CART_ITEMS_ORDER_OPTION,
    key: CART_ITEMS_ORDER_OPTION,
    'data-test-id': CART_ITEMS_ORDER_OPTION_TEST_ID,
  },
  {
    label: 'By name A to Z',
    value: 'a-z',
    id: A_Z_ORDER_OPTION,
    key: A_Z_ORDER_OPTION,
    'data-test-id': A_Z_ORDER_OPTION_TEST_ID,
  },
  {
    label: 'By display order',
    value: 'display-order',
    id: DISPLAY_ORDER_OPTION,
    key: DISPLAY_ORDER_OPTION,
    'data-test-id': DISPLAY_ORDER_OPTION_TEST_ID,
  },
  {
    label: 'By rates Low to High',
    value: 'low-to-high',
    id: RATES_LOW_TO_HIGH_OPTION,
    key: RATES_LOW_TO_HIGH_OPTION,
    'data-test-id': RATES_LOW_TO_HIGH_OPTION_TEST_ID,
  },
  {
    label: 'By rates High to Low',
    value: 'high-to-low',
    id: RATES_HIGH_TO_LOW_OPTION,
    key: RATES_HIGH_TO_LOW_OPTION,
    'data-test-id': RATES_HIGH_TO_LOW_OPTION_TEST_ID,
  },
];

const SecondStep: React.FC = observer(() => {
  const {
    secondStepController: { form },
  } = useGenerateProposalPageStore();

  return (
    <section data-test-id={SECOND_STEP_TEST_ID}>
      <ProposalGenerationStepHeader
        title="Sorting Options"
        info="Select how you would like the proposal content to be sorted."
      />
      <RadioGroupStyled
        value={form.fields.sortingSetting.value}
        onChange={(e): void => {
          form.onRadioGroupChange(e, 'sortingSetting');
        }}
        radioButtons={radioButtons}
      />
    </section>
  );
});

export default SecondStep;
